import { render, staticRenderFns } from "./FormularioAlterarSenha.vue?vue&type=template&id=011b3cbb&scoped=true&"
import script from "./FormularioAlterarSenha.vue?vue&type=script&lang=js&"
export * from "./FormularioAlterarSenha.vue?vue&type=script&lang=js&"
import style0 from "./FormularioAlterarSenha.vue?vue&type=style&index=0&id=011b3cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b3cbb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011b3cbb')) {
      api.createRecord('011b3cbb', component.options)
    } else {
      api.reload('011b3cbb', component.options)
    }
    module.hot.accept("./FormularioAlterarSenha.vue?vue&type=template&id=011b3cbb&scoped=true&", function () {
      api.rerender('011b3cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/FormularioAlterarSenha.vue"
export default component.exports